import styled from 'styled-components'

export const ConstrainedImageContainer = styled.div`
  display: flex;
`
